import MultiSelectionList from './MultiSelectionList';

export default MultiSelectionList;
